import logo from './images/logo.png';
import './App.css';
import Text28 from './Text28';
import Text24 from './Text24';
import t from './translations/translate.ts';
import { TranslationContextProvider } from 'schummar-translate/react';
import Loader from './Loader.js';
import React from 'react';
import axios from 'axios';
import ErrorPage from './ErrorPage';
import LOAD_ERROR_TYPES from './enums/LoadErrorTypes';
import ButtonPrimary from './buttons/ButtonPrimary.js';
import isDemoEnabled from './demo_mode/is_demo_enabled.js';
import DemoAccount from './demo_mode/demo_account.js';
import CONSTS from './Constants.js';

import {ifRightToLeft, ifLeftToRight} from './utils/ifLangDir.js';
import { useLocale } from './LocaleContext';

function App() {
    const { locale } = useLocale();
    const [loginSaved, setLoginSaved] = React.useState(false);
    const [jsonData, setJsonData] = React.useState(null);
    const [familyToken, setFamilyToken] = React.useState(null);
    const [userToken, setUserToken] = React.useState(null);

    React.useEffect(() => {
        var loginOk = false;
        if (localStorage.getItem("login_familyToken")) {
            loginOk = true;
        }
        setLoginSaved(loginOk || isDemoEnabled());
        setFamilyToken(localStorage.getItem("login_familyToken"));
        setUserToken(localStorage.getItem("login_userToken"));
    }, []);

    React.useEffect(() => {
        if (!loginSaved) return;

        const fetchData = async () => {
            try {
                if (isDemoEnabled()){
                    const d = new DemoAccount();
                    var data = {
                        "responseFamily": d.family,
                        "responseProfile": d.supporter,
                    };
                    console.log("demo loaded :)");
                    setJsonData(data);
                }else{
                    const responseFamily = await axios.get(`${CONSTS.BASE_API_URL}/supporters/${userToken}/families/${familyToken}`);
                    const responseProfile = await axios.get(`${CONSTS.BASE_API_URL}/supporters/${userToken}`);
                    var data = {
                        "responseFamily": responseFamily.data,
                        "responseProfile": responseProfile.data,
                    };
                    setJsonData(data);
                }
            } catch (error) {
                setJsonData(-1);
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, [loginSaved, userToken, familyToken]);

    var wasClickedWithFamily = localStorage.getItem('wasClickedWithFamily') || 'not_set';
    if(wasClickedWithFamily ==  localStorage.getItem('login_familyToken') || ''){
        window.location.href = "/home";
    }
    if (!loginSaved) {
        return <ErrorPage errType={LOAD_ERROR_TYPES.AUTH_TOKEN_NOT_FOUND} />;
    }
    if (jsonData == null) return Loader();
    if (jsonData == -1) return <ErrorPage errType={LOAD_ERROR_TYPES.AUTH_TOKEN_NOT_FOUND} />;
    
    document.body.style.direction = ifRightToLeft() ? 'rtl' : 'ltr';


    return (
        <div style={{overflowY: 'scroll', overflowX: 'hidden', 
            direction: ifRightToLeft() ? 'rtl' : 'ltr',
        height: '100vh'}} className='AppBody'>
            <header>
                <img src={logo} className="App-logo" alt="logo" />
            </header>
            <div className="App">
                <TranslationContextProvider locale={locale}>

                    <Text28>{t('helloName', { name: jsonData.responseProfile.full_name.split(" ")[0] })}</Text28>
                    <Text24>{t('thanksForFamily', { family_name: jsonData.responseFamily.title })}</Text24>
                    <p style={{ textAlign: 'left', fontSize: 12 }}>
                        {t('signingIn_1')}
                        <a style={{ whiteSpace: 'nowrap' }} href='/docview/TERMS'>{t('termsOfUse')}</a>
                        {t('signingIn_2')}
                        <a style={{ whiteSpace: 'nowrap' }} href='/docview/PRIVACY'>{t('privacyPolicy')}</a>
                        {t('signingIn_3')}
                    </p>
                    <div style={{ height: 18 }}></div>
                    <ButtonPrimary
                        onClick={() => {
                            localStorage.setItem('wasClickedWithFamily', familyToken);
                            window.location.href = "/home";
                        }}>
                        {t('alwaysReady')}
                    </ButtonPrimary>

                </TranslationContextProvider>
            </div>
        </div>
    )
}
export default App;
